import { Action } from 'redux';

import { FlowSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { EnterFlowSubspace } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { FlowDetailWithUsageInfo } from '../models/FlowInfo';

export interface EnterFlowSubspaceReduxAction extends Action {
  readonly flowDetailInfo: FlowDetailWithUsageInfo;
  readonly subspaceName: FlowSubspaceName;
}

export function enterFlowSubspace(
  flowDetailInfo: FlowDetailWithUsageInfo,
  subspaceName: FlowSubspaceName,
): EnterFlowSubspaceReduxAction {
  return {
    type: EnterFlowSubspace,
    flowDetailInfo,
    subspaceName,
  };
}

export const isEnterFlowSubspaceAction = isActionFactory<EnterFlowSubspaceReduxAction>(EnterFlowSubspace);
